var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1638_304",
    transform: "scale(0.0149254)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1638_304",
    width: 67,
    height: 67,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAACXBIWXMAAC4jAAAuIwF4pT92AAACWElEQVR4nO2awVHDMBBFPx4KoAH3QDqADsjVJ9IBLiEVkA7IyVfSAaECUkJm3EAq8DCaSIMnkWVJXkmR2XeDOJ71Z1f/SwYMwzAMwzAMwzA3wN1lCV1VfgJ4+Cd/nFXRtEf1w73mgm8A73FrSsK6LwR0nYG/7niZrQzAoWjaxeUvi4GLVwBO4WtKwkk+3xVaMYqmHfzCDBDjcdA9hnZMFF1VirXjbUZC7IumfR76cGhMFGsAx5FrckF0+9JUq1EMOS7GG2TESj6PnxhSkIPskJzZFE27G6vfuGb06aryB8BjhoKIMV+MdQVsOqPHMlO7XdoIARcxZFqrJ5UVn0Eb1WE9JoqM0qk2ZZpwGRNFDunUywWdxcjEbq82YTb4dIYQZC/siqLqAOyKpvWqzUsMicge1otTJCbtqbzFuNHNnLWN6pjSGSqd3ordbuT4ejNJDJwFEfM5qQgCSLYMk8WQpLbb0U2YDSRiSBtLtX44pUwTzgnURIJ0ajyscYVqTBSriIdB5G5GKkZku619UqYJ6s6IlU5FytxS35RcDJwFqQOm02CLdRAxJKHslsRGdQQTI9DZ6eSUaYLUWnV0VfkF4IngVs6HNa6EHBMF1dlpcJcKLgaR3dZUKdNE8DFRdFX5AeDV46ukKdNEjDFR1B7pNOoRYzQxPMclmI3qiNkZKp3a2u3W5pUgJdHWjD4WryqtXwlSErUzeozZbdTxUCQRQ+42h8ZlHTJlmkgyJgrNYVDwlGki1Zgo+pu55K8ekopxYbdkZ5lZ01XlnP/nlGEYhmEYhmEYxh4Av/xGx5ugqNWAAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.edd7b3a3081110756d5388cf07288499.svg";
export { ForwardRef as ReactComponent };